// extracted by mini-css-extract-plugin
export default {"row":"RequestLinkedTransaction_row__LMLPo","text":"RequestLinkedTransaction_text__pLvUX","link":"RequestLinkedTransaction_link__15SnG"};